<template>
    <q-dialog persistent v-model="pageModel.view">
        <q-card style="width: 700px; max-width: 90vw;">
            <q-card-section v-if="pageModel.exist_title">
                <div class="text-h6">{{ pageModel.title }}</div>
            </q-card-section>

            <q-separator v-if="pageModel.exist_title"/>

            <q-card-section style="max-height: 80vh" class="scroll" v-html="pageModel.body"></q-card-section>

            <q-separator />

            <q-card-actions align="right">
                <q-btn push label="닫기" color="primary" v-close-popup />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup>
import { reactive } from "vue";
import sanitizeHtml from 'sanitize-html';
import {$utils} from "@/assets/js/utils";

let pageModel = reactive({
    view: false
    , exist_title: true
    , param: Object
});

function openDialog(_title, _body) {
    pageModel.title = sanitizeHtml(_title);

    if (_body.startsWith('/img/')) {
        pageModel.body = '<img src="' + _body + '" style="width: 100%; height: auto;">';
    } else {
        pageModel.body = sanitizeHtml(_body);
    }

    pageModel.exist_title = $utils.isNotBlank(pageModel.title);
    pageModel.view = true;
}

defineExpose({ openDialog });
</script>
